import React from "react";
import SignUpComponent from "components/signUpComponent/SignUpComponent";

function SignUp() {
  return (
    <div>
      <SignUpComponent />
    </div>
  );
}

export default SignUp;
